export default {
  exportUnit: 'Jednostka eksportowa',
};
